import clsx from 'clsx';
import { JSX } from 'react';

type HeadingProps = {
	level: 1 | 2;
	text: React.ReactNode;
	withoutMargin?: boolean;
	center?: boolean;
};

export const Heading = ({
	level = 2,
	text,
	withoutMargin = false,
	center = false,
}: HeadingProps) => {
	const Component = `h${level}` as JSX.ElementType;
	const className = clsx('font-semibold', {
		'text-[32px]': level === 1,
		'text-2xl xl:text-5xl/[1.3] 2xl:text-[64px]/[1.3]': level === 2,
		'mb-6 2xl:mb-12': !withoutMargin,
		'text-center': center,
	});

	return <Component className={className}>{text}</Component>;
};
